import { APP_CONFIG } from "../constants/global-variables.js";

export async function getSports() {
  const url = `${APP_CONFIG.URL.apiBasePath}ajax/sports`;

  try {
    const res = await axios.get(url, {
      headers: {
      },
    });

    return res.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}
